module.exports = __webpack_public_path__ + "static/media/FuturaStd-Medium.b97df2a7.svg";